module.exports = __webpack_public_path__ + "assets/svg/Icons/48/messages-blue-21def7.svg";